import { AbstractFormControl } from "./form-control";

export class InputControl extends AbstractFormControl<HTMLInputElement> {

    getName(): string {
        return this.element.name;
    }

    getValue() {
        return this.element.value;
    }

    setValue(value: any): void {
        if (value === undefined) {
            value = "";
        }
        this.element.value = value;
    }

    /** @override */
    select(): void {
        this.element.select();
    }

    setEnabled(enabled: boolean): void {
        this.element.disabled = !enabled;
    }

    insertTextAtCaret(text: string) {
        this.element.value = text;
    }

    matches(text: string): boolean {
        let value = this.getValue();
        if (value) {
            return text.toLowerCase().includes(value.toLowerCase());
        }
        return true; // Blank => All
    }
}